import React from "react";
import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="grain min-h-screen">
      <header className="border-b" style={{ borderColor: "var(--border-default)" }}>
        <div className="max-w-3xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="font-display text-xl text-neutral-100" data-testid="legal-home-link">gully</Link>
          <Link to="/privacy" className="text-sm text-neutral-400 hover:text-neutral-200">Privacy</Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16" data-testid="terms-page">
        <p className="label-eyebrow mb-3">terms</p>
        <h1 className="font-display font-light text-3xl sm:text-4xl tracking-tight mb-2">A few honest things to know.</h1>
        <p className="text-neutral-500 mb-12 text-sm">Last updated {new Date().toLocaleDateString("en-CA", { year: "numeric", month: "long" })}.</p>

        <div className="space-y-10 text-neutral-300 leading-relaxed">
          <section>
            <h2 className="font-display text-lg text-neutral-100 mb-3">What Gully is</h2>
            <p>Gully is a cricket companion — a coach you can message to think through matches, practice, mindset, tactics and preparation. The Cricket Reviews and insights are <em>educational</em>. They're a thinking partner, not a guarantee of better results.</p>
          </section>

          <section>
            <h2 className="font-display text-lg text-neutral-100 mb-3">What Gully is not</h2>
            <p>Gully is not medical advice. Not mental health treatment. Not legal advice. Not financial advice. If something serious is going on, please talk to a qualified professional. Cricket-related injuries — see a physio or doctor, not a chatbot.</p>
          </section>

          <section>
            <h2 className="font-display text-lg text-neutral-100 mb-3">Your decisions are yours</h2>
            <p>You're the one playing the game. Anything Gully suggests is a coaching idea, not an instruction. You're responsible for the calls you make in training and in matches.</p>
          </section>

          <section>
            <h2 className="font-display text-lg text-neutral-100 mb-3">Under 18?</h2>
            <p>If you're under 18, please use Gully with a parent or coach's permission. We want this to be a healthy space for young cricketers, and a trusted adult in the loop helps.</p>
          </section>

          <section>
            <h2 className="font-display text-lg text-neutral-100 mb-3">What you can send Gully</h2>
            <p>Your own match notes, your own video clips, your own Cricket Reviews — all welcome. Please don't upload broadcast footage, copyrighted content or anything that isn't yours to share. If you wouldn't show it to your club coach, don't show it to Gully.</p>
          </section>

          <section>
            <h2 className="font-display text-lg text-neutral-100 mb-3">Fair use</h2>
            <p>The free tier is for individual cricketers reflecting on their own game. Please don't automate it, scrape it, or run a coaching business off it without talking to us first.</p>
          </section>

          <section>
            <h2 className="font-display text-lg text-neutral-100 mb-3">Changes</h2>
            <p>We'll keep these terms short and human. If something material changes, we'll update the date at the top.</p>
          </section>
        </div>

        <div className="mt-16 text-sm text-neutral-500">
          Questions? <Link to="/" className="text-[#A7F3D0]">Back to gully</Link> · <Link to="/privacy" className="text-[#A7F3D0]">Read the privacy notes</Link>
        </div>
      </main>
    </div>
  );
}
